import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'rti-url-modal',
    templateUrl: './rti-url-modal.component.html',
    styleUrls: ['./rti-url-modal.component.scss'],
    standalone: false
})
export class RtiUrlModalComponent implements OnInit {
  public obj: any = {
    url: '',
    errors$: new BehaviorSubject<any>(null),
    warnings$: new BehaviorSubject<any>(null),
    onChange: () => null,
  }
  constructor(public activeModal: NgbActiveModal) {}

  public ngOnInit(): void {
    this.obj.validate = () => this.validate(this.obj);
    this.obj.validate;
}

  public validate(obj) {
    obj.errors = {};
    obj.warnings = {};
    obj.hasErrors = false;

    if (!obj.url?.trim())
      obj.errors['url'] = 'Input required.';

    obj.hasErrors = Object.keys(obj.errors).length;
    obj.syncAlerts?.();
  }

}
